import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import 'swiper/css';

const generateUniqueId = (text, index) => {
  const id = text
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .toLowerCase();
  return document.getElementById(id) ? `${id}-${index}` : id;
};

const createTabs = () => {
  const programContent = document.querySelector('.program-content');
  const headers = programContent.querySelectorAll('h2');
  const tabsMenu = document.getElementById('tabsMenu');

  if (!headers.length || !tabsMenu) return;

  // Add IDs to headers
  headers.forEach((header, index) => {
    header.id = generateUniqueId(header.textContent, index);
  });

  // Create menu items
  headers.forEach((header) => {
    const itemSpan = document.createElement('span');
    const itemLink = document.createElement('a');
    itemLink.href = `#${header.id}`;
    itemLink.textContent = header.textContent;
    itemSpan.appendChild(itemLink);
    itemSpan.classList.add('program-tabs__item');
    tabsMenu.appendChild(itemSpan);
  });
};

domReady(() => {
  const programTabs = document.querySelector('.program-tabs');
  if (!programTabs) return;

  createTabs();

  new Swiper('.tabs-swiper', {
    wrapperClass: 'program-tabs__wrapper',
    direction: 'horizontal',
    loop: false,
    slidesPerView: 'auto',
    slideClass: 'program-tabs__item',
    watchOverflow: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
  });
});
